const topSwiper = new Swiper(".top-swiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  slidesPerView: 1,
  simulateTouch: true,
  loop: true,
  centeredSlides: true,
  shortSwipes: true,
  autoplay: {
    delay: 4000,
  },
  touchRatio: 0.8,
  breakpoints: {
    1: {
      slidesPerView: 1,
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    501: {
      spaceBetween: 20,
      slidesPerView: 1.4,
      speed: 1500,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    836: {
      spaceBetween: 20,
      slidesPerView: 1.2,
      speed: 1500,
    },
  },
});
